import React from "react";
import { Modal, Button } from "react-bootstrap";

const TicketDetailModal = ({ show, onHide, categories }) => {
  if (!categories) return null;

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Ticket Category Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Name:</strong> {categories.name}
        </p>
        <p>
          <strong>Status:</strong> {categories.status}
        </p>
        <p>
          <strong>Description:</strong> {categories.description}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TicketDetailModal;
